import { style } from '@vanilla-extract/css';

export const noScroll = style({
  overflow: 'hidden',
});
